module.exports = __webpack_public_path__ + "img/jdihn.06074f1.png";